import { render, staticRenderFns } from "./HomeMatches.vue?vue&type=template&id=6b18aa7a&"
import script from "./HomeMatches.vue?vue&type=script&lang=js&"
export * from "./HomeMatches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports